import { createContext, useContext } from 'react';

/* @internal */
export type ChipSize = 'medium' | 'small';

interface ChipContextState {
	readonly size: ChipSize;
}

/* @internal */
export const ChipContext = createContext<ChipContextState>({ size: 'medium' });

/**
 * Gives the `Chip` sub components access to the size of the `Chip` they are
 * rendered inside of, so they can adapt themselves to it. The color is
 * inherited through CSS instead.
 *
 * @internal
 */
export function useChipContext(): ChipContextState {
	return useContext(ChipContext);
}
